import { DistributionFrequencyEnumKeys } from "./shapes/DistributionFrequencyEnum"

const ListSchedulesItemSchema = {
  startDate: { format: 'date' },
  nextDate: { format: 'date' },
  distributionFrequency: { enum: DistributionFrequencyEnumKeys },
  shouldRoundCents: { type: 'boolean' },
  totalAmount: { type: 'number' },
  createdAt: { format: 'date-time' },
  updatedAt: { format: 'date-time' }
}

export default ListSchedulesItemSchema
